export const SET_REPOSITORIES_DATA = 'set_repositories_data';
export const FILTER_REPOSITORIES = 'filter_repositories';
export const SET_IMMUTABLE = 'set_immutable_data';
export const LOADING = 'repos_data_loading';
export const ERROR = 'repos_data_error';
